import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const module={
    state : {
        routertag:'index',
        siderHide:false,
        btn:[],
        menu:[]  
    },
    mutations:{
        setRouter(state,routertag){
            state.routertag=routertag;
        },
        setSiderHide(state,siderHide){
            state.siderHide=siderHide;
        },
        setBtn(state,btn){
            state.btn=btn;
        },
        setMenu(state, menu) {
            state.menu = menu;
        }
    }
}

const store = new Vuex.Store(module)
export default store



// WEBPACK FOOTER //
// ./src/store/store.js